import type { TRuleWithTheme } from 'styles/theme';

export const modal: TRuleWithTheme = () => ({
    '& .ant-modal-content': {
        padding: '1.5rem',
    },

    '& .ant-modal-header': {
        padding: 0,

        borderBottom: 'none',
    },

    '& .ant-modal-body': {
        padding: 0,
    },

    '& .ant-modal-footer': {
        padding: 0,

        borderTop: 'none',
    },

    '& .ant-modal-close-x': {
        width: '2.5rem',
        height: '2.5rem',

        lineHeight: '2.5rem',
    },
});

export const header: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: '-0.19rem',
});

export const title: TRuleWithTheme = () => ({
    '&.ant-typography': {
        fontSize: '1.56rem',
        lineHeight: 1.33,

        margin: 0,
    },
});

export const content: TRuleWithTheme = () => ({
    marginTop: '0.5rem',
    fontSize: '0.88rem',
});

export const fieldRow: TRuleWithTheme = () => ({
    marginTop: '1.5rem',

    '& label': {
        fontSize: '0.625rem',
    },
});

export const componentRow: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '> div': {
        flex: 1,
    },

    '> div:first-child': {
        paddingRight: '0.625rem',
        minWidth: '50%',
    },

    '> div:last-child': {
        paddingLeft: '0.625rem',
        minWidth: '50%',

        '> label': {
            left: '1.375rem',
        },
    },
});

export const textArea: TRuleWithTheme = () => ({
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
});

export const bottomButtons: TRuleWithTheme = () => ({
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'flex-end',

    columnGap: '1rem',

    marginTop: '2.5rem',
});
